export const JustificationsNotWinner = [
  { text: 'Não atendeu descritivo', value: 'Não atendeu descritivo' },
  { text: 'Preço', value: 'Preço' },
  { text: 'Falta de anexos', value: 'Falta de anexos' },
  { text: 'Não atendeu prazo', value: 'Não atendeu prazo' },
  { text: 'Tempo Randômico', value: 'Tempo Randômico' },
  { text: 'Disputa fechada', value: 'Disputa fechada' }
];
